import React from 'react';

const Console = () => {
  return 'Приветствую:) Спасибо за проверку! С наступающими;)  \n 1. Вёрстка страниц приложения и навигация между ними +30  \n 2. Меню с настройками +45 \n -выбрать один из нескольких (минимум 8) фонов +10 \n -выбрать одну из нескольких (минимум 4) ёлок +10 \n -включить/отключить падающий снег +10 \n -включить/отключить новогоднюю музыку +10 \n -выбранные настройки сохраняются в local storage(кроме музыки) +5 \n 3. Гирлянда +35 (Внешний вид не совсем соответсвует +5) \n 4. Игрушки в избранном +80 \n Самооценка 190/200';
};

export default Console;
